import React, { Suspense, useState } from 'react';
import PropTypes from 'prop-types';

import withWebView from 'ggApp/shared/hocs/withWebView';
import { HeaderProvider, Loading } from '@devsbb/header-ui';
import { useFeatureFlags, HEADER_V2 } from 'ggApp/modules/featureFlag';
import { connect } from 'react-redux';
import { loadingAllFlags } from 'ggApp/modules/featureFlag/selectors';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Wrap, Top, Bottom } from './styled';
import B2CRedirection from '../../modals/B2CRedirection';
import HeaderV2 from '../HeaderV2/HeaderV2';
import { useDeviceInfo } from '../HeaderV2/useDeviceInfo';
import { DEVICE_TYPE } from '../HeaderV2/types';
import { LoaderWrapper } from '../HeaderV2/styles';

const TopWithChecker = withWebView(Top);

const Header = (props) => {
    const {
        isLoggedIn,
        headerRef,
        isDesktopUser,
        loadingAllFlagsValue,
        isTransparent,
        className,
    } = props;
    const { deviceType } = useDeviceInfo();
    const { isFlagEnabled, getFeatureFlag } = useFeatureFlags();
    const flag = getFeatureFlag(HEADER_V2);
    const isHeaderV2Enabled = flag?.flagID && isFlagEnabled(HEADER_V2);
    const [shouldShowMenu, setshouldShowMenu] = useState(false);
    const [b2cRedirectionModal, setb2cRedirectionModal] = useState(null);

    const showMenu = () => {
        setshouldShowMenu(true);
    };

    const closeMenu = () => {
        setshouldShowMenu(false);
    };

    const toggleMenu = () => {
        setshouldShowMenu((prevState) => !prevState);
    };

    const createModalRefB2cRedirect = (modal) => {
        setb2cRedirectionModal(modal);
    };

    const mobile = deviceType !== DEVICE_TYPE.Desktop;

    return (
        <>
            {loadingAllFlagsValue ? (
                <HeaderProvider>
                    <LoaderWrapper>
                        <Loading mobile={mobile} />
                    </LoaderWrapper>
                </HeaderProvider>
            ) : (
                <>
                    {isHeaderV2Enabled ? (
                        <Suspense
                            fallback={
                                <HeaderProvider>
                                    <LoaderWrapper>
                                        <Loading mobile={mobile} />
                                    </LoaderWrapper>
                                </HeaderProvider>
                            }
                        >
                            <HeaderV2
                                withTransparentHeader={isTransparent}
                                isHeaderV2Enabled={isHeaderV2Enabled}
                            />
                        </Suspense>
                    ) : (
                        <>
                            <Wrap
                                className={className}
                                shouldShowMenu={shouldShowMenu}
                                ref={headerRef}
                            >
                                <TopWithChecker
                                    isDesktopUser={isDesktopUser}
                                    isTransparent={isTransparent}
                                    isLoggedIn={isLoggedIn}
                                    b2cRedirectionModal={b2cRedirectionModal}
                                />
                                <Bottom
                                    shouldShowMenu={shouldShowMenu}
                                    isTransparent={isTransparent}
                                    showMenu={showMenu}
                                    closeMenu={closeMenu}
                                    toggleMenu={toggleMenu}
                                    b2cRedirectionModal={b2cRedirectionModal}
                                />
                            </Wrap>
                            <B2CRedirection modalRef={createModalRefB2cRedirect} />
                        </>
                    )}
                </>
            )}
        </>
    );
};

Header.propTypes = {
    isLoggedIn: PropTypes.bool,
    isDesktopUser: PropTypes.bool,
    headerRef: PropTypes.func,
};

Header.defaultProps = {
    isLoggedIn: false,
    isDesktopUser: true,
    headerRef: () => {},
};

const enhance = compose(
    connect(
        createStructuredSelector({
            loadingAllFlagsValue: loadingAllFlags,
        }),
    ),
);
export default enhance(Header);
